import { useMemo } from 'react'

import { useLoadAllItemsQuery } from '@sequencehq/api/utils'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { MINUTES } from '@sequencehq/utils/dates'

export const useAllUsers = () => {
  const usersQuery = useLoadAllItemsQuery(
    dashboard20240730Client.getUsers,
    { limit: 100 },
    { staleTime: 1 * MINUTES }
  )

  const users = useMemo(() => {
    const items = usersQuery.data?.pages.flatMap(page => page.items) ?? []

    return items.map(user => ({
      email: user.email,
      label: user.email,
      id: user.id,
      roles: (user.roles ?? []).map(role => role.roleName)
    }))
  }, [usersQuery.data])

  return {
    users,
    isPending: usersQuery.isPending,
    isError: usersQuery.isError
  }
}
